import { StarIcon } from "@/components/icons/StarIcon";
import { cn } from "@/lib/utils";

type StarRatingProps = {
  /** Bewertung von 0 bis `max`, auf halbe Sterne gerundet. */
  value: number;
  max?: number;
  className?: string;
};

/**
 * Reine Anzeige, ohne Klick. `Rating.tsx` rundet auf ganze Sterne und loest
 * beim Klick Konfetti aus — fuer Lektionen gedacht, nicht fuer Zitate.
 */
const StarRating = ({ value, max = 5, className }: StarRatingProps) => {
  const rounded = Math.round(value * 2) / 2;

  return (
    <div
      className={cn("flex text-sky-75", className)}
      role="img"
      aria-label={`${String(rounded).replace(".", ",")} von ${max} Sternen`}
    >
      {Array.from({ length: max }, (_, i) => (
        <StarIcon
          key={i}
          fill={rounded >= i + 1 ? "full" : rounded >= i + 0.5 ? "half" : "empty"}
          className="size-6 shrink-0"
        />
      ))}
    </div>
  );
};

export { StarRating };
